import Crud from '../crud'
import ApiService from '../../utils/api.service'
import { API_VERSION } from '../../utils/config'
import { BOOK, FETCH_FORM_SCHEMA, VALIDATE_VALUES } from '../actions/productTemplate'

const endpoint = 'product-templates'
const crud = new Crud(endpoint)

const actions = {
  ...crud.actions,

  [FETCH_FORM_SCHEMA]: async (_, { name, version }) => {
    const { data } = await ApiService.get(`api/${API_VERSION}/${endpoint}/${name}/${version}/form-schema`)
    return data
  },

  [VALIDATE_VALUES]: async (_, { name, version, formValues, metadata, cancelToken }) => {
    const { data } = await ApiService.post(
      `api/${API_VERSION}/${endpoint}/${name}/${version}/validate-values`,
      { form_values: formValues, metadata },
      { cancelToken }
    )
    return data
  },

  [BOOK]: async (_, { name, version, formValues, metadata }) => {
    const { data } = await ApiService.post(`api/${API_VERSION}/product-tree/`, { template: { name, version }, form_values: formValues, metadata })
    return data
  },
}

export default {
  state: { ...crud.state },
  getters: { ...crud.getters },
  actions,
  mutations: { ...crud.mutations },
}
